import SeoLandingPage from "@/components/SeoLandingPage";
import heroImage from "@/assets/commercial-interior-demolition.jpg";

const CommercialInteriorDemolition = () => (
  <SeoLandingPage
    slug="commercial-interior-demolition-wisconsin"
    metaTitle="Commercial Interior Demolition | Green Bay & Northeast WI"
    metaDescription="Commercial interior demolition for offices, retail, restaurants, and light-industrial spaces in Northeast Wisconsin. Selective tear-out and debris hauling."
    h1="Commercial Interior Demolition in Northeast Wisconsin"
    heroImage={heroImage}
    heroIntro="Prepare offices, retail spaces, restaurants, and light-industrial interiors for renovation, turnover, or a new tenant with a clearly managed demolition scope."
    serviceName="Commercial Interior Demolition"
    bullets={[
      "Office partition, drywall, door, ceiling, and finish removal.",
      "Retail fixture, display, casework, counter, and fitting-room removal.",
      "Restaurant front-of-house finish and approved equipment-area tear-out.",
      "Commercial carpet, VCT, tile, laminate, and underlayment removal.",
      "Debris staging, loading, hauling, and documented handoff.",
      "Phased and after-hours scheduling when agreed during estimating.",
    ]}
    whyUs={[
      "A single accountable crew coordinates selective removal and debris hauling.",
      "Written scopes support owners, contractors, property managers, and tenant-improvement teams.",
      "Work zones and access routes are planned around occupied or shared properties when feasible.",
      "Local coverage for Green Bay, De Pere, Appleton, and surrounding Northeast Wisconsin markets.",
    ]}
    processSteps={[
      { title: "Share plans and site photos", detail: "Send available drawings, scope notes, site rules, access details, and the required completion condition." },
      { title: "Walk and price the scope", detail: "We identify exclusions, utilities, hazardous-material responsibilities, schedule constraints, and debris logistics." },
      { title: "Coordinate the work", detail: "Approved selective demolition proceeds by area or phase with communication to the designated project contact." },
      { title: "Clear and document", detail: "Debris is removed and the approved space is left broom-clean for the next construction phase." },
    ]}
    faqs={[
      { q: "What commercial spaces do you demolish?", a: "We perform selective interior tear-outs for offices, retail stores, restaurants, rental units, and light-industrial or warehouse support spaces." },
      { q: "How is commercial interior demolition priced?", a: "Pricing considers square footage, material types, access, working hours, floor level, disposal volume, site rules, phasing, and the turnover condition. Plans and photos help define the estimate." },
      { q: "Can you work after business hours?", a: "After-hours or phased scheduling may be available when site access, noise rules, staffing, and disposal logistics are agreed in advance." },
      { q: "Do you handle permits and hazardous materials?", a: "Permit and testing responsibilities are assigned in the written scope. Suspected asbestos, lead, mold, or other regulated material must be evaluated before disturbance." },
      { q: "Can you coordinate with our general contractor?", a: "Yes. We can work from an approved demolition scope and coordinate access, sequence, stopping points, and handoff expectations with your project lead." },
    ]}
    ctaHeadline="Preparing a commercial space for its next use?"
  />
);

export default CommercialInteriorDemolition;
